import { useQuery } from '@tanstack/react-query';
import { getGlobalFieldBindings } from '@dealstack/frontend/shared/dataExchange/services/documentTemplates.service';

export const buildGlobalFieldBindingsQueryKey = (templateId: string): string =>
	`global-field-bindings-${templateId}`;

export const useGlobalFieldBindingsQuery = (templateId: string | null) =>
	useQuery({
		queryKey: [buildGlobalFieldBindingsQueryKey(templateId ?? '')],
		queryFn: () => getGlobalFieldBindings(templateId ?? ''),
		enabled: !!templateId,
	});
